import { tokens, media, css, CompositeFieldConfig, SelectFieldConfig } from '@sail/ui';
import { assignTokens } from '@sail/engine';
// TODO: Remove gap label/description + input/error gap
// Customizations for the sail phoneNumberField component
export const compositeFieldCustomization = CompositeFieldConfig.customize({
    uses: [
        css({
            columnGap: `${tokens.space.large}`,
            rowGap: `${tokens.space.small}`,
            [media.up(tokens.viewport.small)]: {
                alignItems: 'center'
            }
        }),
        assignTokens(tokens.font.label.small.lineHeight, '1.5')
    ],
    subviews: {
        inputs: {
            uses: [
                css({
                    gridRow: '1/2',
                    gridColumn: '2'
                }),
                SelectFieldConfig.customize({
                    subviews: {
                        button: {
                            css: {
                                ':hover:not(:active):not([aria-disabled="true"])': {
                                    backgroundColor: 'form'
                                },
                                ':focus:not(:disabled)': {
                                    backgroundColor: 'form'
                                }
                            }
                        }
                    }
                })
            ]
        },
        description: {
            uses: [
                css({
                    gridColumn: '1',
                    alignSelf: 'start'
                })
            ]
        },
        error: {
            uses: [
                css({
                    display: 'block',
                    gridArea: '2/2',
                    [media.up(tokens.viewport.small)]: {
                        marginTop: `${tokens.space.small}`
                    },
                    ':not([data-invalid*="true"]) > &': {
                        display: 'contents'
                    }
                })
            ]
        }
    }
});

//# sourceMappingURL=compositeField.js.map